import { gql } from '@apollo/client';

// Fragment for post fields
export const POST_FIELDS = gql`
  fragment PostFields on Post {
    id
    postId
    title
    slug
    excerpt
    date
    content
    featuredImage {
      node {
        sourceUrl
        altText
        mediaDetails {
          width
          height
        }
      }
    }
    categories {
      nodes {
        id
        name
        slug
      }
    }
    author {
      node {
        name
        avatar {
          url
        }
      }
    }
  }
`;

// Get posts with pagination
export const GET_POSTS = gql`
  ${POST_FIELDS}
  query GetPosts($first: Int!, $after: String) {
    posts(first: $first, after: $after, where: { orderby: { field: DATE, order: DESC } }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...PostFields
      }
    }
  }
`;

// Get single post by slug
export const GET_POST_BY_SLUG = gql`
  ${POST_FIELDS}
  query GetPostBySlug($slug: ID!) {
    post(id: $slug, idType: SLUG) {
      ...PostFields
    }
  }
`;

// Get all categories
export const GET_CATEGORIES = gql`
  query GetCategories {
    categories(first: 100, where: { hideEmpty: true }) {
      nodes {
        id
        name
        slug
        count
        description
      }
    }
  }
`;

// Get posts by category
export const GET_POSTS_BY_CATEGORY = gql`
  ${POST_FIELDS}
  query GetPostsByCategory($categorySlug: String!, $first: Int!, $after: String) {
    posts(
      first: $first
      after: $after
      where: {
        categoryName: $categorySlug
        orderby: { field: DATE, order: DESC }
      }
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        ...PostFields
      }
    }
  }
`;

// Get recent posts (for sidebar/widgets)
export const GET_RECENT_POSTS = gql`
  query GetRecentPosts($first: Int!) {
    posts(first: $first, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        id
        postId
        title
        slug
        date
        excerpt
        featuredImage {
          node {
            sourceUrl
            altText
          }
        }
        categories {
          nodes {
            name
            slug
          }
        }
      }
    }
  }
`;

// Get featured/sticky posts
export const GET_FEATURED_POSTS = gql`
  ${POST_FIELDS}
  query GetFeaturedPosts($first: Int!) {
    posts(
      first: $first
      where: {
        onlySticky: true
        orderby: { field: DATE, order: DESC }
      }
    ) {
      nodes {
        ...PostFields
      }
    }
  }
`;

// Fallback: Get latest posts when no sticky posts
export const GET_LATEST_POSTS = gql`
  ${POST_FIELDS}
  query GetLatestPosts($first: Int!) {
    posts(first: $first, where: { orderby: { field: DATE, order: DESC } }) {
      nodes {
        ...PostFields
      }
    }
  }
`;

// Get Audio Files from WordPress Media Library
export const GET_AUDIO_FROM_MEDIA = gql`
  query GetAudioFiles($first: Int = 50) {
    mediaItems(
      first: $first
      where: {
        orderby: { field: DATE, order: DESC }
      }
    ) {
      nodes {
        id
        databaseId
        title
        description
        mediaItemUrl
        mimeType
        fileSize
        date
        altText
      }
    }
  }
`;

// Search posts
export const SEARCH_POSTS = gql`
  ${POST_FIELDS}
  query SearchPosts($search: String!, $first: Int = 20) {
    posts(
      first: $first
      where: {
        search: $search
        orderby: { field: DATE, order: DESC }
      }
    ) {
      nodes {
        ...PostFields
      }
    }
  }
`;
